import { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { AuthClassification } from 'src/hooks/auth/auth.interface';

import { LayoutProps } from './Layout.interface';
import { OwnerOperatorLayout } from './OwnerOperatorLayout';
import { StandardLayout } from './StandardLayout';

export const Layout: React.FC<LayoutProps> = (props) => {
  const { userRole } = useContext(AuthDataProvider);

  const isOwnerOperator = userRole === AuthClassification.OWNER_OPERATOR;

  if (isOwnerOperator) {
    return <OwnerOperatorLayout>{props.children}</OwnerOperatorLayout>;
  }

  return <StandardLayout>{props.children}</StandardLayout>;
};
